import { useCallback, useState } from 'react'
import { useInstance } from '@10000/react'
import { Body, Box } from '../widgets'
import { InputScreen, signUpBackground, useBackground, useShell, useStack } from '../layout'
import { Digits, useForm } from '../forms'
import { createAccount, resendCode } from './request.js'
import { PasswordSetUp } from '../onboarding'

export const AccountVerification = ({ active, email, region, free }) => {
  const { setInstance } = useInstance()
  const { replaceStack } = useStack()

  useBackground().set(mobile => ({ active, fade: free, ...signUpBackground(mobile, true, false, free) }))
  useShell({ active, mode: free ? 'navigate' : 'progress narrow', step: 2, max: free ? 3 : 6 })

  const [error, setError] = useState(false)

  const verifyAccount = useCallback(
    ({ code }) => createAccount(email, code, region)
      .then(({ user: { region, tenantId, signupData } }) => {
        setInstance({ region, id: tenantId })
        const data = JSON.parse(signupData)
        if(!data?.free) {
          replaceStack(PasswordSetUp)
        }
      }).catch(() => setError(true)),
    [replaceStack, email, region, setInstance, setError]
  )

  return (
    <InputScreen
      fade={!free}
      footerButton="Next"
      onSubmit={verifyAccount}
      title="Enter your verification code"
      description={<>Please enter the code we have sent to <Body alt bold>{email}</Body></>}
      centered={free}
    >
      <DigitWrapper email={email} error={error} resetError={() => setError(false)} />
    </InputScreen>
  )
}

const DigitWrapper = ({ email, error, resetError }) => {
  const { submit } = useForm()
  const [codeResent, setCodeResent] = useState(false)
  const handleNewCode = () => resendCode(email).then(() => setCodeResent(true))

  return <Box fullWidth column gap={16}>
    <Digits name="code" onComplete={submit} error={error} onChange={resetError} />
    <a onClick={handleNewCode} style={{ textAlign: 'center' }}>Send code again</a>
    {codeResent && <Body align="center">Code sent, please check your email</Body>}
  </Box>
}